import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from "../../appTheme";

export const addEditCustomerStyle = StyleSheet.create({
    outerContainer: {
        flex: 1,
        backgroundColor: appColors?.lightBackgroundColor
    },
    stepperView: {
        backgroundColor: appColors?.light,
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "space-around",
        borderRadius: 5,
        marginVertical: 5,
        alignItems: "center"
    },
    stepperInnerView: {
        width: "50%",
        alignItems: "center",
        padding: 10,
    },
    sectionView: {
        margin: 15,
        backgroundColor: appColors?.light,
        borderRadius: 10,
        marginTop: 5
    },
    sectionHeading: {
        marginHorizontal: 15,
        marginBottom: 10
    },
    generalSectionView: {
        flexDirection: "row",
        alignItems: "flex-start",
        flexWrap: "wrap",
        marginVertical: 10
    },
    dropdownLabelStyle: {
        marginHorizontal: 15,
        marginBottom: 5,
        fontSize: fontSize?.smallerFontSize
    },
    dropdownContainerStyle: {
        borderWidth: 0.3,
        borderColor: appColors?.grey,
        // position: "relative", top: 0
    },
    dropdownStyle: {
        borderWidth: 0.3,
        borderRadius: 5,
        borderColor: appColors?.grey
    },
    inputContainerStyle: { paddingVertical: 0 },
    approvedView: {
        flexDirection: "row",
        alignItems: "center",
        paddingHorizontal: 15,
        paddingBottom: 30
    },
    labelStyle: {
        fontSize: fontSize?.smallerFontSize,
        color: appColors?.labelColor,
        fontFamily: appFonts?.medium
    },
    checkBoxContainerStyle: { margin: 0, padding: 0, paddingLeft: 10 },
    wholesaleView: {
        flexDirection: "row",
        alignItems: "flex-start",
        paddingHorizontal: 5,
    },
    permissionOuterView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginVertical: 10
    },
    permissionView: {
        flexDirection: "row",
        alignItems: "center",
        marginHorizontal: 20
    },
    additionalInfoStyle: {
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "wrap",
        marginVertical: 10
    },
    settingsView: { marginVertical: 10, marginHorizontal: 5, },
    addressTypeView: {
        flexDirection: "row",
        alignItems: "center",
        marginVertical: 10
    },
    loyaltyBalanceView: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginVertical: 20,
        marginHorizontal: 15
    }

})